import { FC } from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute: FC<any> = ({ Component }) => {
  const token  = localStorage.getItem('token');
  return token ? <Component /> : <Navigate to="/login" />;
};

export default PrivateRoute;
